/**
 * Horizontal tab strip under the page header. Every tab is a URL — this
 * renders react-router NavLinks and lets the route decide which tab is
 * current, not local state. "A tab strip that keeps state in memory is a
 * segmented control wearing tabs."
 * Spec: assets/handoffs/design_handoff_app_shell, Rules — settings.
 *
 * @param {Array<{key,label,to,badge?,exact?}>} tabs - cap 8; past that the
 *   strip needs a rethink, not an overflow menu
 */
import React from "react";
import { NavLink } from "react-router-dom";
import Badge from "../../../theme/untitled/Badge/Badge";
import styles from "./SettingsTabs.module.scss";

const SettingsTabs = ({ tabs = [] }) => {
  const tabLinks = tabs.map((tab) => (
    <NavLink
      key={tab.key}
      to={tab.to}
      exact={tab.exact !== false}
      className={styles.tab}
      activeClassName={styles["tab--current"]}
    >
      {tab.label}
      {tab.badge != null && (
        <Badge color="gray" size="sm" className={styles.badge}>
          {tab.badge}
        </Badge>
      )}
    </NavLink>
  ));

  return (
    <div className={styles.root}>
      <div className={styles.scroller}>{tabLinks}</div>
    </div>
  );
};

export default SettingsTabs;
